/**
 * Paylaşılan **baş harf rozeti** (Reuse Mandate). Kişi adının yanında duran, adın baş harflerinden
 * üretilmiş yuvarlak bir işaret.
 *
 * Kurallar:
 * - **Fotoğraf yoktur ve olmayacaktır**: HR kaynağı (`CEO_SUITE_HR_VIEW`) fotoğraf taşımaz; baş harf,
 *   satırları gözle ayırmaya yeter.
 * - Renk **SABİTTİR** — `--avatar-bg` (kullanıcı kararı 2026-08-27). Figma'da (180561:29596) tüm
 *   rozetler aynı laciverti taşıyor; değer o frame'in render'ından piksel örneklenerek ölçüldü.
 *
 *   <p>ÖNCEDEN renk **addan/sicilden türetiliyordu** (beş tonluk palet + toplam hash), gerekçesi
 *   "aynı kişi her yerde aynı renkte görünsün, liste sıralanınca rozet zıplamasın" idi. O karar geri
 *   alındı: ayırt etme işini rozetin **yanındaki ad** yapıyor, renk değil — dolayısıyla palet, bilgi
 *   taşımayan bir görsel çeşitlilikten ibaretti ve tasarımla çelişiyordu. Renk artık CSS'te
 *   (`.ui-avatar`) durur; bileşen satır-içi stil üretmez.
 * - **Renk tek bilgi taşıyıcısı değildir**: rozetin yanında adın kendisi yazar; rozet `aria-hidden`'dır
 *   ve ekran okuyucuya tekrar okunmaz.
 */
export interface AvatarProps {
  /** Görünen tam ad; baş harfler bundan türetilir. */
  name: string
  className?: string
}

/** Ad → en çok iki baş harf. Tek kelimelik adda ilk harf yeter; boş adda rozet çizilmez (çağıran karar verir). */
function initialsOf(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return ''
  if (parts.length === 1) return parts[0].slice(0, 1).toLocaleUpperCase('tr-TR')
  return (parts[0].slice(0, 1) + parts[parts.length - 1].slice(0, 1)).toLocaleUpperCase('tr-TR')
}

export default function Avatar({ name, className }: Readonly<AvatarProps>) {
  const initials = initialsOf(name)
  if (initials === '') return null
  return (
    <span className={`ui-avatar${className ? ` ${className}` : ''}`} aria-hidden="true">
      {initials}
    </span>
  )
}
